import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslatePipe} from '@ngx-translate/core';

export interface VisibilityWarningData {
  mapName: string;
  usage: 'embedding' | 'publishing' | 'publishing and embedding';
  deactivating?: 'embedding' | 'publishing';
}

@Component({
  selector: 'app-visibility-warning-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatTooltipModule, TranslatePipe],
  template: `
    <div class="w-100 d-flex justify-content-between align-items-center dialog-header">
      <h2 class="align-items-center d-flex m-0 p-0">
        <span class="icon-smap-concept-warning me-2"></span>
        {{ 'MISC_DIALOGS.VISIBILITY_WARNING.TITLE' | translate }}
      </h2>
      <span class="icon-smap-action-close close-button" mat-dialog-close
            [matTooltip]="'PUBLISH_STORE.CLOSE_TOOLTIP' | translate"></span>
    </div>

    <div mat-dialog-content class="p-3 px-4">
      <p class="m-0">
        @if (data.deactivating) {
          {{ 'MISC_DIALOGS.VISIBILITY_WARNING.MESSAGE_DEACTIVATING' | translate:{ usage: data.deactivating, name: data.mapName } }}
        } @else {
          {{ 'MISC_DIALOGS.VISIBILITY_WARNING.MESSAGE_PRIVATE' | translate:{ name: data.mapName, usage: data.usage } }}
        }
      </p>
    </div>

    <div mat-dialog-actions class="d-flex justify-content-center">
      <button class="dialog-action-btn dialog-action-btn-primary" mat-dialog-close cdkFocusInitial>
        {{ 'AI_ERROR.OK' | translate }}
      </button>
    </div>
  `,
  styles: []
})
export class VisibilityWarningDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<VisibilityWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VisibilityWarningData
  ) {}
}
